import React, { useEffect, useState } from "react";
import axios from "axios";
import CustomTab from "../../components/common/CustomTab";
import { getCourseList, getAllCategoriesUrl } from "../../utils/urls";
import EditDescriptionTab from "./EditDescriptionTab";
import EditAccessTab from "./EditAccessTab";

const EditCourse = ({ courseId, onClose }) => {
    const [categoryList, setCategoryList] = useState([]);
    const [courseData, setCourseData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCourseDetails = async () => {
            setLoading(true);
            setError(null);
            try {
                const { data } = await axios.get(getCourseList);
                const foundCourse = data?.data?.find((course) => course.id === courseId);
                if (!foundCourse) {
                    throw new Error(`Course with ID ${courseId} not found`);
                }
                setCourseData({  
                    id: foundCourse.id,
                    title: foundCourse.title || "",
                    description: foundCourse.description || "",
                    category_id: foundCourse.category_id?.category_id || foundCourse.category_id || "",
                    banner_file: foundCourse.course_banner_img_url || "",
                    access_for_all_user: foundCourse.access_for_all_user ?? false,
                    access_for_verified_user: foundCourse.access_for_verified_user ?? false,
                    availability_schedule: foundCourse.availability_schedule || "Immediate",
                    schedule_date: foundCourse.schedule_date || "",
                    sub_category_id: foundCourse.sub_category || [],
                });
            } catch (error) {
                console.error("Error fetching course details:", error.message);
                setError("Failed to load course details. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${getAllCategoriesUrl}?is_all=true`);
                if (response.data?.success) {
                    const activeCategories = response.data.data.filter((cat) => cat.is_active);
                    setCategoryList(activeCategories);
                } else {
                    console.error("Categories fetch failed:", response.data);
                }
            } catch (error) {
                console.error("Error fetching categories:", error.message);
            }
        };

        fetchCourseDetails();
        fetchCategories();
    }, [courseId]);

    const tabs = [
        {
            title: "Description",
            component: courseData && (
                <EditDescriptionTab
                    courseData={courseData}
                    categoryList={categoryList}
                    onSubmit={() => {
                        onClose();
                    }}
                />
            ),
        },
        {
            title: "Access",
            component: courseData && (
                <EditAccessTab
                    courseData={courseData}
                    onSubmit={() => {
                        onClose();
                    }}
                />
            ),
        },
    ];

    if (error) {
        return <div className="p-4 text-red-600">{error}</div>;
    }

    return loading ? (
        <div className="p-4">Loading course details...</div>
    ) : (
        <CustomTab tabList={tabs} tabIndex={0} />
    );
};

export default EditCourse;